<script>
  import { videoState } from "./stores";

  function changeCardState() {
    videoState.set(false);
  }
</script>

<div class="сontainer">
<div class="textContainer">
<button class="quitButton" style="margin-top: 20px" on:click={changeCardState}>X</button>
<br>
<div class="image">
<iframe width="100%" height="100%" src="https://www.youtube.com/embed/2f8L2gKICzo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>

</div>
</div>

<style>
  .сontainer {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    z-index: 10;
    backdrop-filter: blur(80px);
    -webkit-backdrop-filter: blur(80px);
    border: 1px solid rgba(42, 42, 54, 1);
    padding: 20px;
  }
  .textContainer {
    /* width: 300px; */
    /* margin: 20px; */
    width: 100%;
    height: 100%;
    text-align: left;
    /* backdrop-filter: blur(80px); */
  }
  /* .button {
        width: 200px;
        height: 60px;
        margin-top: 20px;
        background: black;
        border: 1px solid black;
        color: white;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 5px 5px 0 cyan;
        cursor: pointer;
      }
      .button:hover:enabled {
        background: rgba(255, 255, 255, 0.5);
        color: black;
      } */

  .quitButton {
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
    background: none;
    border: 1px solid rgba(42, 42, 54, 1);
    cursor: pointer;
  }
  .quitButton:hover {
    background: black;
    color: white;
  }

  .image {
    width: 280px;
    height: 210px;
    background: grey;
    box-shadow: 5px 5px 0 cyan;
  }
</style>